import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";

export default function RelatedProducts({ productId }) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (!productId) return;
    let cancelled = false;
    api.get(`/products/${productId}/related?limit=4`)
      .then((r) => { if (!cancelled) setItems(r.data || []); })
      .catch(() => { /* hide gracefully */ });
    return () => { cancelled = true; };
  }, [productId]);

  if (items.length === 0) return null;

  return (
    <section className="border-t border-[#EAE4D3] mt-20 pt-16" data-testid="related-products">
      <div className="flex items-baseline justify-between flex-wrap gap-2 mb-8">
        <h2 className="font-serif text-3xl tracking-tight">You may also love</h2>
        <Link to="/shop" className="text-xs uppercase tracking-[0.2em] text-[var(--accent)] hover:underline">Browse all →</Link>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
        {items.map((p) => (
          <Link to={`/product/${p.id}`} key={p.id} data-testid={`related-${p.id}`}
            className="group rounded-3xl overflow-hidden border border-[#EAE4D3] bg-[#FDFBF7] hover:border-[var(--accent)]/60 transition">
            <div className="aspect-[4/5] bg-[#F5F2EA] overflow-hidden">
              {p.image_url && <img src={p.image_url} alt={p.title} className="w-full h-full object-cover transition group-hover:scale-105" />}
            </div>
            <div className="p-3">
              <div className="font-serif text-sm leading-tight line-clamp-2">{p.title}</div>
              {Number(p.price) > 0 && (
                <div className="mt-1 text-xs gold-text">${Number(p.price).toFixed(2)}</div>
              )}
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
